function ErrorPage() {
  return (
    <>
      <p className="text-2xl my-10">404 Not Found</p>
    </>
  );
}

export default ErrorPage;
